import React, { useEffect, useContext } from 'react';
import _get from 'lodash/get';
import { useHistory } from 'react-router';
import { useDispatch } from 'react-redux';
import { useData, useStatus, isNormal } from 'resift';
import SourceContext from 'helpers/SourceContext';
import useSource from 'pages/Directory/helpers/useSource';
import { fetchDirectory } from 'store/directories';
import { fetchSource } from 'store/sources';
import makeGetLatestSourceFile from 'pages/Source/fetches/makeGetLatestSourceFile';
import makeSourceCreateBaseUrl from 'pages/Directory/helpers/makeSourceCreateBaseUrl';
import MapAttributes from './MapAttributes';
import { SourceType } from 'types/Source';

import { AUTHORIZE_DATA_ACCESS_URL } from 'pages/Directory/consts';

function Container() {
  const history = useHistory();
  const sourceContext = useContext(SourceContext);
  const dispatch = useDispatch();
  const { sourceInfo } = sourceContext;
  const { directoryId, sourceId, type } = sourceInfo;
  const baseUrl = makeSourceCreateBaseUrl(directoryId, sourceId);
  const getLatestDataCSVFile = makeGetLatestSourceFile(sourceId, 'data');
  const lastDataCsv = useData(getLatestDataCSVFile);
  const dataCsvFetchStatus = useStatus(getLatestDataCSVFile);
  const source = useSource(sourceId);

  useEffect(() => {
    if (
      (type === SourceType.AZURE_AD || type === SourceType.GOOGLE) &&
      !_get(source, ['authorizationStatus', 'isAuthorized'], false)
    ) {
      history.push(`${baseUrl}${AUTHORIZE_DATA_ACCESS_URL}`);
    }
  }, []);

  useEffect(() => {
    dispatch(getLatestDataCSVFile());
  }, []);

  useEffect(() => {
    // (note - pearl) Need to do this so withSource would have directory info
    dispatch(fetchDirectory(directoryId));
    dispatch(fetchSource(sourceId));
  }, []);

  if (type === SourceType.CSV && !isNormal(dataCsvFetchStatus)) {
    return <div>Loading...</div>;
  }

  return (
    <MapAttributes
      shouldDirectToCsvUpload={
        type === SourceType.CSV &&
        !_get(source, ['setupProgress', 'csvOptOut'], false) &&
        !lastDataCsv
      }
    />
  );
}

export default Container;
